var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3429 6.50503L2.44781 0.385036C2.08231 0.133012 1.70217 0 1.37672 0C0.662194 0 0.188477 0.599463 0.188477 1.56413V14.4322C0.188477 14.9035 0.325472 15.2972 0.528568 15.5713C0.734775 15.8491 1.05737 15.9961 1.40589 15.9961C1.7312 15.9961 2.09631 15.8628 2.46167 15.6112L11.3488 9.4912C11.9201 9.09735 12.2334 8.56725 12.2332 7.99786C12.2332 7.42873 11.915 6.89863 11.3429 6.50503Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.478090305366a7b1ea473fc291bfaeb1.svg";
export { ForwardRef as ReactComponent };